import _os2 from "os";
import _core2 from "./core.js";
import _realtime2 from "./realtime.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSignals = void 0;
var _os = _os2;
var _core = _core2;
var _realtime = _realtime2;

const getSignals = function () {
  const realtimeSignals = (0, _realtime.getRealtimeSignals)();
  const signals = [..._core.SIGNALS, ...realtimeSignals].map(normalizeSignal);
  return signals;
};

exports.getSignals = getSignals;

const normalizeSignal = function ({
  name,
  number: defaultNumber,
  description,
  action,
  forced = false,
  standard
}) {
  const {
    signals: {
      [name]: constantSignal
    }
  } = _os.constants;
  const supported = constantSignal !== undefined;
  const number = supported ? constantSignal : defaultNumber;
  return {
    name,
    number,
    description,
    supported,
    action,
    forced,
    standard
  };
}; //# sourceMappingURL=signals.js.map


export default exports;